// src/phase4/ui/MoneyDisplay.ts
// Money display component - Pure Phaser UI component
// Displays current FLOP currency

import Phaser from 'phaser';

export class MoneyDisplay extends Phaser.GameObjects.Container {
  private amountText?: Phaser.GameObjects.Text;
  private icon?: Phaser.GameObjects.Text;
  private bg?: Phaser.GameObjects.Graphics;
  private currentAmount: number = 0;

  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y);
    scene.add.existing(this);
    this.createDisplay();
    this.setDepth(100);
  }

  private createDisplay(): void {
    // Background
    this.bg = this.scene.add.graphics();
    this.bg.fillStyle(0x201e1a, 0.9);
    this.bg.fillRoundedRect(-60, -18, 120, 36, 6);
    this.bg.lineStyle(1, 0x3a362e);
    this.bg.strokeRoundedRect(-60, -18, 120, 36, 6);
    this.add(this.bg);

    // FLOP icon
    this.icon = this.scene.add.text(-45, 0, '₣', {
      fontSize: '20px',
      color: '#ffd700',
      fontFamily: 'monospace',
      fontStyle: 'bold',
    }).setOrigin(0.5);
    this.add(this.icon);

    // Amount text
    this.amountText = this.scene.add.text(-15, 0, '0', {
      fontSize: '18px',
      color: '#ffd700',
      fontFamily: 'monospace',
      fontStyle: 'bold',
    }).setOrigin(0, 0.5);
    this.add(this.amountText);
  }

  update(amount: number): void {
    this.currentAmount = amount;
    this.amountText?.setText(amount.toLocaleString());

    // Flash effect when amount changes
    this.scene.tweens.add({
      targets: [this.bg, this.amountText, this.icon],
      alpha: { from: 1, to: 0.5, duration: 50 },
      yoyo: true,
      repeat: 1,
    });
  }

  getAmount(): number {
    return this.currentAmount;
  }

  setPosition(x: number, y: number): this {
    super.setPosition(x, y);
    return this;
  }

  destroy(): void {
    super.destroy();
  }
}

export default MoneyDisplay;
